import React, { FC, useState } from "react";
import moment from "moment";
import "./contentLists.scss";
import pdfIcon from "../../../assets/icons/pdf-icon.svg";
import videoIcon from "../../../assets/icons/video-icon.svg";
import subjectIcon from "../../../assets/icons/content-library-subject.svg";
import authorIcon from "../../../assets/icons/content-library-author.svg";
import CardMenu from "../../../shared/components/CourseComponents/CardMenu";
// import ContentForm from "../ContentForm";
import { Col, Row, Tag } from "antd";

interface ContentListsProps {
  contents: any;
  currentContent: any;
  setCurrentContent: Function;
  setShowContent: Function;
  setShowDelete: Function;
  setShowForm:Function;
  setShowQuickQuizForm: Function;
}

const ContentLists: FC<ContentListsProps> = (props) => {
  const {
    contents,
    currentContent,
    setCurrentContent,
    setShowContent,
    setShowDelete,
    setShowForm,
    setShowQuickQuizForm,
  } = props;

  const [menuVisible, setMenuVisible] = useState<boolean>(false);

  const handleEdit = (id:any) => {
    setShowForm(true);
    setCurrentContent(id);
  };

  const handleDelete = (id:any) => {
    setShowDelete(true);
    setCurrentContent(id);
  };

  return (
    <>
      <Row className="content-list" gutter={[24, 12]}>
        {contents.map((content: any, i: number) => (
          <Col xs={8} xl={6}>
            <div
              className={
                "content-list__card" +
                (menuVisible && currentContent.id === content.id
                  ? " display-overlay"
                  : "")
              }
              key={i}
              onClick={(event) => {
                setCurrentContent(content?.id);
                setShowContent(true);
              }}
            >
              <div className="content-list__thumbnail">
                <img
                  src={content?.displayPictureUrl}
                  alt=""
                  className="content-list__thumbnail__image"
                />
                <div className="content-list__type">
                  <img
                    src={content?.contentType === "pdf" ? pdfIcon : videoIcon}
                    alt=""
                  />
                  {`${content?.contentLength} ${
                    content?.contentType === "pdf" ? " pages" : " mins"
                  }`}
                </div>
                <div className="content-list__overlay">
                  <div className="content-list__details">
                    {/* <div className="content-list__subject">
                      <img src={subjectIcon} alt="" /> Physics,Chemistry, +3
                    </div> */}
                    <div className="content-list__subject">
                      <img src={authorIcon} alt="" /> {content?.description}
                    </div>
                  </div>
                  <div
                    className="content-list__menu"
                    onClick={(event) => {
                      event.stopPropagation();
                      //setCurrentContent(content?.id);
                    }}
                  >
                    <CardMenu
                      menuText="Content"
                      handleEdit={()=>handleEdit(content?.id)}
                      handleDelete={()=>handleDelete(content?.id)}
                      handleVisibleChange={setMenuVisible}
                      useMenuIconWhite={true}
                    />
                  </div>
                </div>
              </div>
              <div className="content-list__title">{content?.title}</div>
              <div className="content-list__meta">
                <span>ID: {content?.id}</span>
                <span>{moment(content?.createdAt).format("DD MMM YYYY, hh:mm A")}</span>
              </div>
              <div className="content-list__footer">
                <div className="content-list__visibility">
                  {content?.visibility === "unlisted" ? (
                    <Tag color="red">Unlisted</Tag>
                  ) : (
                    <Tag color="green">Public</Tag>
                  )}
                </div>
                <div
                  className="content-list__quickquiz"
                  onClick={(event) => {
                    event.stopPropagation();
                    setCurrentContent(content?.id);
                    setShowQuickQuizForm(true);
                  }}
                >
                  Quick Quiz
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ContentLists;
